
import axios from 'axios'
import couponActivityAdd from './../component/couponActivityAdd.vue'
import couponView from './component/coupon/couponView.vue'
import couponUser from './component/coupon/couponUser.vue'
export default {
  className: 'couponActivity',
  title: '购物代金券活动',
  render: (record) => {
    let stringFields = ['name']
    return stringFields.map(f => record[f]).join('-')
  },
  fields: [
    {
      name: 'name'
    },
    {
      name: 'details',
      note: '商品代金券详情',
      listWhere: (where) => {
        where.couponType = 'shopping'
        where.isDel = {
          $ne: true
        }
      }
    },
    {
      name: 'type',
      note: '发放类型'
    },
    {
      name: 'isEnable',
      note: '是否启用'
    },
    {
      name: 'residentialQuarters',
      note: '参与小区'
    },
    {
      name: 'day',
      note: '商品代金券有效期',
      validators: [
        (val) => /^[1-9]\d*$/.test(val) ? null : '请填写正确的商品代金券有效期'
      ]
    }
  ],
  search: [
    'name',
    'isEnable',
    'day'
  ],
  action: {
    create: {
      component: couponActivityAdd
    },
    edit: false,
    view: {
      type: 'row',
      text: '查看',
      component: couponView
    },
    viewUser: {
      type: 'row',
      text: '参与用户',
      component: couponUser
    },
    open: {
      type: 'row',
      text: '启用',
      hidden: ({ record }) => {
        return record && record.isEnable
      },
      callback: async ({ record, vm, modelName }) => {
        await vm.confirm('警告', '您确定要启用此活动吗？')
        // 更改订单状态
        let cleaning = await vm.$tkParse.put(`/classes/couponActivity/${record.objectId}`, {
          isEnable: true
        })
        if (cleaning) {
          vm.$notification['success']({
            message: '操作成功',
            description: '此活动已启用'
          })
        }
        vm.refresh()
      }
    },
    close: {
      type: 'row',
      text: '关闭',
      hidden: ({ record }) => {
        return record && !record.isEnable
      },
      callback: async ({ record, vm, modelName }) => {
        await vm.confirm('警告', '您确定要关闭此活动吗？')
        // 更改订单状态
        let cleaning = await vm.$tkParse.put(`/classes/couponActivity/${record.objectId}`, {
          isEnable: false
        })
        if (cleaning) {
          vm.$notification['success']({
            message: '操作成功',
            description: '此活动已关闭'
          })
        }
        vm.refresh()
      }
    },
    down: {
      type: 'row',
      text: '下载海报',
      callback: async ({ record, vm, modelName }) => {
        vm.$notification['info']({
          message: '下载中',
          description: '海报下载中，请稍后'
        })
        let url = `https://url-to-pdf.mokekeji.com/api/render?url=https://publicity.mokekeji.com/runji-poster?objectId=${record.objectId}`
        const res = await axios.get(`${url}&output=screenshot&viewport.width=${375 * 1}&viewport.height=${(812 * 1)}`,
          {
            responseType: 'arraybuffer'
          })
        const res1 = await axios.post(`https://cloud.runji.mokekeji.com/files`, res.data)
        window.open(res1.data.url)
        vm.$notification['success']({
          message: '下载成功',
          description: '海报下载成功'
        })
      }
    }
  },
  hooks: {
    beforeFetch ({ where }) {
      where.type = {
        $ne: 'manual'
      }
    }
  }
}
